
import { of } from 'rxjs/internal/observable/of';
import { throwError } from 'rxjs/internal/observable/throwError';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { HolidayState } from './holiday.reducer';
import { FeatureKeys } from '../app.reducer';
import { IHolidaysResponse, IHolidayResponse, DayTime, DayType } from '@signal/asp-data-commons'; 
import { DateTime } from 'luxon';

export class HolidayAdapter {
  static toHolidays(response: IHolidaysResponse) {
    if (`${response.status.code}` === '200') {
      return of(response.data);
    } else {
      return throwError(`${response.status.code} - ${response.status.messages.join(', ')}`);
    }
  }
  static toHoliday(response: IHolidayResponse) {
    if (`${response.status.code}` === '200' || `${response.status.code}` === '201') {
      return of(response.data);
    } else {
      return throwError(`${response.status.code} - ${response.status.messages.join(', ')}`);
    }
  }
}

export const selectHolidaysFeature = createFeatureSelector<HolidayState>(FeatureKeys.HOLIDAYS);


/* To select the appointments loading flag in the dashboard state */
export const selectHolidaysLoading = createSelector(
  selectHolidaysFeature,
  (state: HolidayState) => state.loading
);

export const selectActiveYear = createSelector(
  selectHolidaysFeature,
  (state: HolidayState) => state.activeYear
);

export const selectHolidayState = createSelector(
  selectHolidaysFeature,
  (state: HolidayState) => state
);

export const selectHolidays = createSelector(
  selectHolidaysFeature,
  selectActiveYear,
  (state: HolidayState) => state.holidays.filter(obj =>{
    return  (obj.holidayDate.substr(0, 4) === state.activeYear) || obj.isRecurring
  }).sort((a: any, b: any) => {
    const date1 =  DateTime.fromFormat(`${a.holidayDate}`,'yyyy-MM-dd').toFormat('2020-MM-dd')
    const date2 =  DateTime.fromFormat(`${b.holidayDate}`,'yyyy-MM-dd').toFormat('2020-MM-dd')
      if (new Date(date1) < new Date(date2)) {
          return -1;
        } else if (new Date(date1) > new Date(date2)) {
          return 1;
        }else if (date1 === date2 && a.dayType === DayType.half && b.dayType === DayType.half ){
          if(a.dayTime === DayTime.am && b.dayTime === DayTime.pm){
            return -1;
          }
          else if(a.dayTime === DayTime.pm && b.dayTime === DayTime.am){
            return 1;
          }else{
            return 0;
          }
        }else {
          return 0;
        }
  })
);
